import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import textUtils from "../../common/utilities/TextUtils";
import { GENERIC_RESPONSE_PARAMETER, ADD_UPDATE, getApiPath } from "../../../api/ApiConst"; 
import apiCaller from "../../../api/ApiCaller";
import { TYPES_OPTIONS } from "../../../settings/constants/types";
import { AGGREGATE_OPERATION_TYPE } from "../../../settings/constants/aggregateOperation";

const INITIAL_STATE = {
  requestId: "",
  name: "",
  type: "",
  comment: "",
  pathToTableAttribute: "",
  aggregateColumn: false,
  pathToGroupBy: "",
  aggregateOperation: "DEFAULT",
};

const ResponseParameterAddEdit = ({
  isOpen = false,
  row = null,
  requestId,
  onSuccessCallBack,
  onClose,
}) => {
  const [parameterObj, setParameterObj] = useState({ ...INITIAL_STATE });

  useEffect(() => {
    if (isOpen) {
      const rowId = get(row, "id");
      if (rowId) {
        setParameterObj({
          id: rowId,
          requestId,
          name: get(row, "name", ""),
          type: get(row, "type", ""),
          comment: get(row, "comment", ""),
          pathToTableAttribute: get(row, "pathToTableAttribute", ""),
          aggregateColumn: get(row, "aggregateColumn", false),
          pathToGroupBy: get(row, "pathToGroupBy", ""),
          aggregateOperation: get(row, "aggregateOperation", ""),
        });
        return;
      }

      setParameterObj({ ...INITIAL_STATE, requestId });
    }
  }, [isOpen]);

  const toggle = () => {
    onClose();
  };

  const handleTextChange = (key, value) => {
    setParameterObj((prev) => ({ ...prev, [key]: value }));
  };

  const handleCreateParameter = () => {
    let requestObj = parameterObj;
    if (
      textUtils.isEmpty(requestObj.name, "Name", true) ||
      textUtils.isEmpty(requestObj.type, "Type", true)
    ) {
      return false;
    }

    let url = getApiPath(GENERIC_RESPONSE_PARAMETER, ADD_UPDATE);
    apiCaller.callPostApi(
      url,
      requestObj,
      {},
      (response) => {
        toast.success(
          `Parameter ${parameterObj?.id ? "Update" : "Created"} Successfully`
        );
        onSuccessCallBack();
        toggle();
      },
      (error) => {
        // toast.error(error.response.data.message);
      }
    );
  };

  return (
    <>
      <Modal show={isOpen} onHide={toggle}>
        <Modal.Header closeButton>
          <Modal.Title>{`${
            parameterObj?.id ? "Edit" : "Add"
          } Response Parameter`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group row mb-3">
            <div className="col-lg-12">
              <label>Name *</label>
              <input
                type="text"
                className="form-control input-default"
                placeholder="Name"
                onChange={(e) => handleTextChange("name", e.target.value)}
                value={parameterObj.name}
              />
            </div>
          </div>
          <div className="form-group row mb-3">
            <div className="col-lg-12">
              <label>Type *</label>
              <Select
                options={TYPES_OPTIONS}
                value={{ label: parameterObj.type, value: parameterObj.type }}
                id="type"
                name="type"
                onChange={(e) => handleTextChange("type", e.value)}
                className="react-select-container"
              />
            </div>
          </div>
          <div className="form-group row mb-3">
            <div className="col-lg-12">
              <label>Comment </label>
              <input
                type="text"
                className="form-control input-default"
                placeholder="Comment"
                onChange={(e) => handleTextChange("comment", e.target.value)}
                value={parameterObj.comment}
              />
            </div>
          </div>
          <div className="form-group row mb-3">
            <div className="col-lg-12">
              <label>Path To Table Attribute </label>
              <input
                type="text"
                className="form-control input-default"
                placeholder="Path To Table Attribute"
                onChange={(e) =>
                  handleTextChange("pathToTableAttribute", e.target.value)
                }
                value={parameterObj.pathToTableAttribute}
              />
            </div>
          </div>
          <div className="form-group row mb-3">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-6">
                  <input
                    type="checkbox"
                    name="aggregateColumn"
                    checked={parameterObj.aggregateColumn}
                    onChange={(e) =>
                      handleTextChange("aggregateColumn", e.target.checked)
                    }
                  />
                  <label className="ms-2">Aggregate Column</label>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group row mb-3">
            <div className="col-lg-12">
              <label>Path To GroupBy </label>
              <input
                type="text"
                className="form-control input-default"
                placeholder="Path To GroupBy"
                onChange={(e) =>
                  handleTextChange("pathToGroupBy", e.target.value)
                }
                value={parameterObj.pathToGroupBy}
              />
            </div>
          </div>
          <div className="form-group row mb-3">
            <div className="col-lg-12">
              <label>Aggregate Operation</label>
              <Select
                options={AGGREGATE_OPERATION_TYPE}
                value={{ label: parameterObj.aggregateOperation, value: parameterObj.aggregateOperation }}
                id="aggregateOperation"
                name="aggregateOperation"
                onChange={(e) =>
                  handleTextChange("aggregateOperation", e.value)
                }
                className="react-select-container"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCreateParameter}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ResponseParameterAddEdit;
